<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        v-if="aranFilterId"
        xs12
        class="mb-2"
      >
        <v-btn
          flat
          small
          to="/events"
        >
          <v-icon left>arrow_forward</v-icon>
          כל האירועים הפעילים
        </v-btn>
        <h2 class="headline mt-2">
          אירועים פעילים — {{ aranTitle }}
        </h2>
      </v-flex>
      <v-flex
        xs12
        sm6
        md4
        v-for="(event, index) of displayedEvents"
        :key="`activeEvent${event._id || index}`"
      >
        <active-event :event-id="event._id" />
      </v-flex>
      <v-flex>
        <v-progress-linear
          v-if="loadingAranEvents"
          indeterminate
          height="2"
          class="mb-3"
        />
        <v-alert
          :value="true"
          color="white"
          class="grey--text"
          icon="info"
          v-if="!loadingAranEvents && !displayedEvents.length"
        >
          {{ aranFilterId ? 'אין אירועים פעילים בארן זה' : 'אין אירועים פעילים' }}
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ActiveEvent from "./active/ActiveEvent.vue";
import { getAranIdFromEvent } from "@/utils/aran";

export default {
  data: () => ({
    loadingAranEvents: false
  }),

  computed: {
    aranFilterId() {
      const id = this.$route.query.aran;
      return id ? String(id) : null;
    },
    aranTitle() {
      if (!this.aranFilterId) {
        return "";
      }
      const aran = this.$store.state.entities.arans[this.aranFilterId];
      return (aran && aran.name) || this.aranFilterId;
    },
    displayedEvents() {
      const all = this.$store.getters["events/activeEvents"];
      if (!this.aranFilterId) {
        return all;
      }
      const needle = this.aranFilterId;
      return all.filter(event => getAranIdFromEvent(event) === needle);
    }
  },

  watch: {
    aranFilterId: {
      immediate: true,
      handler(aranId) {
        if (aranId) {
          this.loadAranContext(aranId);
        }
      }
    }
  },

  methods: {
    loadAranContext(aranId) {
      this.loadingAranEvents = true;
      this.$store
        .dispatch("ARAN_LOAD_CONTEXT", {
          aranId: String(aranId),
          openAllEvents: false
        })
        .catch(err => {
          console.error(err);
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message || "שגיאה בטעינת אירועי הארן",
            color: "error"
          });
        })
        .finally(() => {
          this.loadingAranEvents = false;
        });
    }
  },

  components: {
    ActiveEvent
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/events/ActiveEvents.vue